// extracted by mini-css-extract-plugin
export default {"modalContent":"section-info-modal_modalContent__Ry+oF","modalTitle":"section-info-modal_modalTitle__p5lPy","modalBody":"section-info-modal_modalBody__kHz3D"};